import React from 'react';

const AboutPage = () => {
    return (
        <main className="bg-[#F9F9F9] min-h-screen">
            {/* ===== ABOUT CONTENT ===== */}
            <section className="px-6 py-16 md:px-12 md:py-32">
                <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-16 lg:gap-24">
                    
                    {/* Text content */}
                    <div className="w-full md:flex-1 order-2 md:order-1">
                        <span className="text-[10px] font-black text-[#D81F26] uppercase tracking-[0.4em] mb-4 block">Our Mission</span>
                        <h1 className="text-4xl md:text-6xl font-black text-black mb-8 leading-[1.1] tracking-tighter">
                            Simpler car ownership <br />
                            <span className="text-[#6B6B6B]">starts with clarity.</span>
                        </h1>
                        
                        <div className="space-y-8 text-black/80">
                            <p className="text-lg md:text-xl font-bold leading-relaxed text-black">
                                CarFido was built to bridge the gap between complex vehicle data and the everyday driver.
                            </p>
                            
                            <p className="text-base leading-relaxed font-medium">
                                Most drivers don't actually have a car problem. They have an information problem. 
                                When something goes wrong, you're left guessing about safety, repairs, and costs.
                            </p>

                            <div className="bg-white/40 backdrop-blur-sm p-8 rounded-[32px] border border-white/20 shadow-sm">
                                <p className="text-lg font-black text-black mb-6 tracking-tight">CarFido provides the answers you need:</p>
                                <ul className="space-y-4">
                                    {[
                                        "What's actually happening under the hood?",
                                        "Is my vehicle safe to drive right now?",
                                        "What are the likely repair costs?",
                                        "Am I about to get overcharged at the shop?",
                                        "How can I prevent this issue in the future?"
                                    ].map((q, i) => (
                                        <li key={i} className="flex items-center gap-4">
                                            <div className="w-5 h-5 rounded-full bg-[#F2F2F2] flex items-center justify-center shrink-0">
                                                <div className="w-1.5 h-1.5 bg-[#414141] rounded-full" />
                                            </div>
                                            <span className="font-bold text-sm text-black/70">{q}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            
                            <p className="text-base leading-relaxed font-medium">
                                Describe what your car is doing, and CarFido turns your symptoms into clear, actionable insights. 
                                Whether you're a DIY enthusiast or just want to be informed at the mechanic, CarFido puts you back in the driver's seat.
                            </p>
                            
                            <div className="pt-6 border-t border-black/5">
                                <p className="text-4xl font-black text-black mb-2 tracking-tighter italic">Clarity.</p>
                                <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#D81F26]">No tools. No confusion. Just ask.</p>
                            </div>
                        </div>
                    </div>

                    {/* Image section */}
                    <div className="w-full md:w-[42%] flex-shrink-0 order-1 md:order-2">
                        <div className="relative group">
                            <div className="absolute inset-0 bg-black/5 blur-[80px] rounded-full -z-10 group-hover:bg-black/10 transition-all duration-1000" />
                            <img
                                src="/future_vehicle.png"
                                alt="Future of Vehicle Ownership"
                                className="w-full h-auto rounded-[48px] shadow-2xl shadow-black/10 object-cover border-[12px] border-white group-hover:scale-[1.02] transition-transform duration-700"
                                style={{ maxHeight: '70vh' }}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default AboutPage;
